import { render, staticRenderFns } from "./formSectionTitle.vue?vue&type=template&id=32670cd6&scoped=true&"
import script from "./formSectionTitle.vue?vue&type=script&lang=js&"
export * from "./formSectionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32670cd6",
  null
  
)

export default component.exports